import { render, staticRenderFns } from "./CollectionPreviewView.vue?vue&type=template&id=43c6f374&scoped=true&"
import script from "./CollectionPreviewView.vue?vue&type=script&lang=ts&"
export * from "./CollectionPreviewView.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionPreviewView.vue?vue&type=style&index=0&id=43c6f374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c6f374",
  null
  
)

export default component.exports